import React from 'react';

import TitleAndDescriptionWithOrder from '@components/nycLanding/_shared/titleAndDescriptionWithOrder';
import { NYCLandingType } from '@utils/types/landings';

import styles from './styles.module.scss';

type Props = {
  order: number;
} & NYCLandingType['outperformance'];

const Outperformance = (props: Props) => {
  const { title, textOne, textTwo, firstItem, secondItem, chartImage, order } =
    props;

  return (
    <div className={styles.outperformance}>
      <div>
        <TitleAndDescriptionWithOrder
          title={title}
          description={`${textOne} <br/><br/> ${textTwo}`}
          order={order}
          containerStyle={styles.titleAndDescription}
        />

        <div className={styles.item}>
          <div className={styles.item__value}>{firstItem.percent}%</div>
          <div className={styles.item__label}>{firstItem.title}</div>
        </div>

        <div className={styles.item}>
          <div className={styles.item__value}>{secondItem.percent}%</div>
          <div className={styles.item__label}>{secondItem.title}</div>
        </div>
      </div>

      <div className={styles.imageWrapper}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src={chartImage} alt={title} />
      </div>
    </div>
  );
};

export default Outperformance;
